import { mainAxios } from "@/mainAxios";
import { getAgenteAccessToken } from "../tokens.service";

const auth = () => ({
    headers: { Authorization: "Bearer " + localStorage.agenteAccessToken },
});

export async function listScripts(params = {}) {
    const p = { ...params };

    if (Array.isArray(p.campaniaIds) && p.campaniaIds.length > 0) {
        p.campaniaId = p.campaniaIds[0];
        delete p.campaniaIds;
    }

    if (p["campaniaIds[]"] != null) {
        const v = p["campaniaIds[]"];
        p.campaniaId = Array.isArray(v) ? v[0] : v;
        delete p["campaniaIds[]"];
    }

    const { data } = await mainAxios.get("/v1/scripts", { params: p, ...auth() });
    return data;
}

export async function getScript(id) {
    const { data } = await mainAxios.get(`/v1/scripts/${id}`, auth());
    return data;
}

export async function createScript(payload) {
    const body = {
        ...payload,
        mostrarEn: Array.isArray(payload.mostrarEn)
            ? payload.mostrarEn.join(",")
            : payload.mostrarEn,
    };
    const { data } = await mainAxios.post("/v1/scripts", body, auth());
    return data;
}

export async function updateScript(id, payload) {
    const body = {
        ...payload,
        mostrarEn: Array.isArray(payload.mostrarEn)
            ? payload.mostrarEn.join(",")
            : payload.mostrarEn,
    };
    const { data } = await mainAxios.put(`/v1/scripts/${id}`, body, auth());
    return data;
}

export async function deleteScript(id) {
    return mainAxios.delete(`/v1/scripts/${id}`, auth());
}

export async function setEstatusScript(id, estatus, publicadoEn = null) {
    const body = { estatus, publicadoEn };
    return mainAxios.put(`/v1/scripts/${id}/estatus`, body, auth());
}

export async function setPrincipalScript(id, archivo_principal_id) {
    return mainAxios.put(
        `/v1/scripts/${id}/principal`,
        { archivoPrincipalId: archivo_principal_id },
        auth()
    );
}

export async function disponiblesScripts(motivo, rolId, campaniaId) {
    const { data } = await mainAxios.get("/v1/scripts/disponibles", {
        params: { motivo, rolId, campaniaId },
        ...auth(),
    });
    return data;
}

export const getAvailableScripts = async ({
    motivo = "PRIMER_LEAD",
    rolId,
    campaniaId = null,
}) => {
    const config = {
        headers: { Authorization: "Bearer " + getAgenteAccessToken() },
        params: { motivo, rolId },
    };
    if (campaniaId != null) config.params.campaniaId = campaniaId;

    const { data } = await mainAxios.get("/v1/scripts/disponibles", config);
    return data;
};